export default function getCurrencyName(currency) {
    switch (currency) {
        case 'EUR': return 'com.s7.currency.eur';
        case 'CNY': return 'com.s7.currency.cny';
        case 'USD': return 'com.s7.currency.usd';
        default: return 'com.s7.currency.rub';
    }
};